import { render, staticRenderFns } from "./patient_diagnose.vue?vue&type=template&id=21e32f81&scoped=true&"
import script from "./patient_diagnose.vue?vue&type=script&lang=js&"
export * from "./patient_diagnose.vue?vue&type=script&lang=js&"
import style0 from "./patient_diagnose.vue?vue&type=style&index=0&id=21e32f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e32f81",
  null
  
)

component.options.__file = "patient_diagnose.vue"
export default component.exports